import AccountPlatforms from 'features/accountPlatforms/pages/AccountPlatforms/AccountPlatforms';

export default AccountPlatforms;
